import * as React from 'react';
import { BaseComponent } from '../BaseComponent';
import { LayoutType } from '../../constants/LayoutConstants';
import { Overlay } from '../../constants/Enums';
import { VisibilityStore } from '../../stores/VisibilityStore';
import { LoadingAnimation } from '../LoadingAnimation';
import { FloorPlanWizard } from './floorplan/FloorPlanWizard';
import { PconLoginIframe } from './PconLoginIframe';
import { PconLoginQuestion } from './PconLoginQuestion';

interface OverlayFrameProps {
    layoutType: LayoutType;
}

interface OverlayFrameState {
    overlay: Overlay;
}

export class OverlayFrame extends BaseComponent<OverlayFrameProps, OverlayFrameState> {
    public componentWillMount(): void {
        this.addStoreListener(VisibilityStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (!this.state.overlay) {
            return null;
        }
        switch (this.state.overlay) {
            case Overlay.PENDING:
                return (
                    <div className="overlay-frame overlay-full">
                        <div style={{background: '#fff', width: '100%', height: '100%', display: 'block'}}>
                            <LoadingAnimation/>
                        </div>
                    </div>
                );
            case Overlay.FLOORPLAN:
                return (
                    <FloorPlanWizard layoutType={this.props.layoutType}/>
                );
            case Overlay.LOGIN:
                return (
                    <PconLoginIframe/>
                );
            case Overlay.LOGIN_QUESTION:
                return (
                    <PconLoginQuestion layoutType={this.props.layoutType}/>
                );
            default:
                break;
        }
        return null;
    }

    protected onChange = (): void => {
        this.setState({
            overlay: VisibilityStore.getState().overlay
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/overlay/OverlayFrame.tsx